export default __webpack_public_path__ + "static/media/DSC06087.947e5208.jpg";